'use strict';

import * as Onyx from '../../lib/onyx.min.js';

import {default as Vehicles} from '../../scripts/vehicles.js';

const MUSIC_VOLUME = 0.65;
const CHEAT_ORANGE_SEQUENCE = [0, 2, 4, 6, 4, 2, 0];
const CHEAT_SILVER_SEQUENCE = [6, 4, 2, 0, 2, 4, 6];

export default class SceneCharacterSelect extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/character-select/index.html',
            clock: new Onyx.Clock({autostart: false})
        });

        this.materialNoSelected = 1;
        this.selectedSequence = [];
    }

    onload(){
        super.onload();

        Onyx.ImportModelFromOBJ.load({src: "res/models/ship_1.obj"}).then((model) => {
            let entity = new Onyx.Entity({
                components: [model]
            }); 

            this.add(entity);
            this.ship = entity;

            this.swapMaterials(0);
        });

        this.ambientLightColor.set(0.2, 0.2, 0.2, 1);
        this.directionalLight.diffuseColor.set(0.8, 0.8, 0.8, 1);

        let camera = new Onyx.Camera({
            nearPlane: 1,
            farPlane: 50,
            transform: new Onyx.Transform({
                position: [-2.8, 5.5, 19],
                rotation: [-0.3, 0, 0, 1]
            })
        });
        // camera.transform.lookAt([0,7,0])
        this.add(camera);
        this.viewports[0].bindToCamera(camera);
        this.viewports[0].clearColor.set(0.1, 0.1, 0.1, 0); // Transparent background

        this.add(new Onyx.Light({
            id: "",
            enabled: true,
            visible: true,
            diffuseColor: new Onyx.Color(0.25, 0.25, 0.25, 1),
            intensity: 1,
            maxDistance: 500,
            transform: new Onyx.Transform({
                position: [-2.5, 15, 15]
            })
        }));

        this.add(new Onyx.Light({
            id: "",
            enabled: true,
            visible: true,
            diffuseColor: new Onyx.Color(255 / 255, 254 / 255, 166 / 255, 1),
            intensity: 1,
            maxDistance: 500,
            transform: new Onyx.Transform({
                position: [0, -15, 0]
            })
        }));

        this.backgroundSprite = new Onyx.Sprite({
            id: "background", 
            src: "res/textures/character-select-background.jpg", 
            pixelsPerUnit: 0.0325, 
            pivot: [0.5, 0.5],
            transform: new Onyx.Transform({
                position: [-2.8, -6.5, -19] //24
            })
        });
        this.backgroundSprite.transform.pitch = -0.3;

        this.backgroundSprite.loadTextures().then(() => {
            let entity = new Onyx.Entity({
                components: [this.backgroundSprite],
                // transform: new Onyx.Transform({
                //     rotation: [0.1, 0, 0]
                // })
            }); 
            this.add(entity);

            game.hideLoadingMask();
        });

        game.music["main"].volume(MUSIC_VOLUME);
        game.music["main"].play();

		// document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.first_name}", centralStation.player.first_name);
		// document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.last_name}", centralStation.player.last_name);
    }

    // @Onyx.handles('click') //, {elementId: 'start'}
    play(){ 
        game.playerColorSelected = this.materialNoSelected;

        game.showLoadingMask();

        game.music["main"].fade(1, 0, 1000);

        this.setTimeout(() => {
            this.clock.stop();
            game.music["main"].stop();
            game.music["main"].volume(1);

            // window.setTimeout(function(){ // Give the browser a second to breathe and cleanup and garbage
                router.navigate("game"); 
            // }, 1000);
        }, 1000);
        
        // game.sfx["sndButtonPress"].play();
    }

    update(...args){
        super.update(...args);

        if(this.ship) this.ship.transform.yaw -= 0.005;
    }

    swapMaterials(materialNo){
        if(!this.ship) return; // No model loaded yet

        // Check sequence for orange/silver car cheats
        this.selectedSequence.push(materialNo);
        for(var i = 0; i < this.selectedSequence.length; i++){
            if(this.selectedSequence[i] !== CHEAT_ORANGE_SEQUENCE[i] && this.selectedSequence[i] !== CHEAT_SILVER_SEQUENCE[i]){
                this.selectedSequence = [materialNo];
                break;
            }
        }
        if(this.selectedSequence.toString() === CHEAT_ORANGE_SEQUENCE.toString()) materialNo = 7;
        if(this.selectedSequence.toString() === CHEAT_SILVER_SEQUENCE.toString()) materialNo = 8;

        let elements = document.getElementsByClassName("select-button");
        for(let element of elements) element.classList.remove("selected");
        if(elements[materialNo]) elements[materialNo].classList.add("selected");

        this.materialNoSelected = materialNo;

        let tX = new Onyx.Tween();
        this.add(tX);
        let tY = new Onyx.Tween();
        this.add(tY);
        let tZ = new Onyx.Tween();
        this.add(tZ);

        document.getElementById("car-name").style.left = "-100vw";
        document.getElementById("car-phrase").style.left = "-100vw";
        document.getElementById("car-stats").style.left = "-100vw";
        document.getElementById("car-alphabet").style.left = "-100vw";

        tX.easeIn(this.ship.transform, "sx", 0, 100, () => {
            Onyx.ImportMaterialsFromMTL.load({src: "res/models/ship_" + (materialNo + 1) + ".mtl"}).then((materials) => {
                for(let mesh of this.ship.components[0].meshes){
                    for(let material of materials){
                        if(material.name == mesh.material.name) mesh.material = material;
                    }
                }

                tX.easeIn(this.ship.transform, "sx", 1, 100, () => {});
                tY.easeIn(this.ship.transform, "sy", 1, 100, () => {});
                tZ.easeIn(this.ship.transform, "sz", 1, 100, () => {});


                document.getElementById("car-name").innerHTML = Vehicles[materialNo].name;
                document.getElementById("car-phrase").innerHTML = Vehicles[materialNo].phrase;
                document.getElementById("car-stats").innerHTML = Vehicles[materialNo].stats;

                document.getElementById("car-name").style.left = "";
                document.getElementById("car-phrase").style.left = "";
                document.getElementById("car-stats").style.left = "";
                document.getElementById("car-alphabet").style.left = "";
            });
        });

        tY.easeIn(this.ship.transform, "sy", 0, 100, () => {});
        tZ.easeIn(this.ship.transform, "sz", 0, 100, () => {});
        
    }
}